import { cn as e } from "../../lib/utils.es.js";
import { getEmbedPortalContainer as t } from "../../lib/embed-portal-container.es.js";
import * as n from "react";
import { jsx as r } from "react/jsx-runtime";
import * as i from "@radix-ui/react-popover";
// libs/ui-lib/src/components/ui/popover.tsx
function a({ ...e }) {
	return /* @__PURE__ */ r(i.Root, {
		"data-slot": "popover",
		...e
	});
}
var o = n.forwardRef(({ ...e }, t) => /* @__PURE__ */ r(i.Trigger, {
	ref: t,
	"data-slot": "popover-trigger",
	...e
}));
o.displayName = "PopoverTrigger";
function s({ className: n, align: a = "center", sideOffset: o = 4, portalContainer: s, ...c }) {
	return /* @__PURE__ */ r(i.Portal, {
		container: s ?? t() ?? void 0,
		children: /* @__PURE__ */ r(i.Content, {
			"data-slot": "popover-content",
			align: a,
			sideOffset: o,
			className: e("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border border-border p-4 shadow-md outline-hidden", n),
			...c
		})
	});
}
function c({ ...e }) {
	return /* @__PURE__ */ r(i.Anchor, {
		"data-slot": "popover-anchor",
		...e
	});
}
export { a as Popover, c as PopoverAnchor, s as PopoverContent, o as PopoverTrigger };
